import { Message } from "element-ui";
import router from "@/router";
import axios from "axios";
// 创建 Axios 实例
const axiosInstance = axios.create({
  // baseURL: "",
  timeout: 30000,
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器

axiosInstance.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (res.flag === false && res.message === "登录失效") {
      Message.error("登录过期，请重新登录！");

      sessionStorage.clear();
      router.replace({ path: "/" });
      window.history.pushState(null, null, window.location.href);

      return Promise.reject(res);
    }
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
